// removed by extract-text-webpack-plugin
module.exports = {"layout-tabbed-wrapper":"layout-tabbed-wrapper___3LlUA","layout-tabbed-main":"layout-tabbed-main___1dUiK","layout-tabbed-content-wrapper":"layout-tabbed-content-wrapper___1Xz7Z","layout-tabbed-content":"layout-tabbed-content___3v02q"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/layout-tabbed/layout-tabbed.module.scss
// module id = 1366
// module chunks = 82